<script setup lang="ts">
import { useCarsListFilters } from '@autobid/ui/composables/car/data/useCarsListFilters'

const { filtersQty, filtersTabActive } = useCarsListFilters()
</script>

<template>
  <button class="relative h-11 w-11" @click="filtersTabActive = true">
    <CommonIconFilter class="text-[#213343]" />
    <span
      v-if="filtersQty"
      class="qty absolute -right-1.5 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-success pt-1 text-xs text-white"
    >
      {{ filtersQty }}
    </span>
  </button>
</template>
